import $ from 'jquery';
import Clipboard from 'clipboard';
const SELECTOR = '[data-copy-clipboard]';
export const copyToClipboard = (() => {
  $(() => {
    new Clipboard('[data-clipboard-target]');
    new Clipboard('[data-clipboard-text]');
  });
})();
